module.exports = __webpack_public_path__ + "static/garnishings02-80bd9c1e1b74ed6eedf4bc8c1fa564ab.jpg";